<template>
  <v-card class="card-base slider">
    <splide class="splide" :class="{ full: full }" :options="options">
      <splide-slide>
        <ItemSlider
          class="slider-item"
          :class="{ full: full }"
          img-name="slider1new.png"
          title="Совершите нотариальное действие без посещения нотариуса"
        >
          <template v-slot:description>
            <span class="description"
              >Составьте заявление, подпишите его вашей УКЭП и направьте через
              наш портал. Результат вы получите в электронном виде, при
              необходимости документ может быть переведен в бумажную
              форму.</span
            >
          </template>
        </ItemSlider>
      </splide-slide>
      <splide-slide>
        <ItemSlider
          class="slider-item"
          :class="{ full: full }"
          img-name="slider2new.png"
          title="Удостоверить у нотариуса сделку тоже можно дистанционно!"
        >
          <template v-slot:description>
            <span class="description">
              Если стороны договора находятся в разных местах, каждый из них
              может прийти к ближайшему нотариусу в оговоренное время.
              <a
                class="link"
                target="_blank"
                href="https://data.notariat.ru/directory/notary/"
                >Найдите нотариуса на нашем портале.</a
              >
            </span>
          </template>
        </ItemSlider>
      </splide-slide>
      <splide-slide>
        <ItemSlider
          img-name="slider3.svg"
          :class="{ full: full }"
          :img-mini="true"
          title="Отслеживайте изменение статуса вашего обращения"
        >
          <template v-slot:description>
            <span class="description"
              >Отслеживайте изменение статуса вашего обращения</span
            >
          </template>
        </ItemSlider>
      </splide-slide>
      <splide-slide>
        <ItemSlider
          class="slider-item"
          :class="{ full: full }"
          img-name="slider4new.png"
          :img-mini="true"
          title="Нотариальное действие требует личного присутствия?"
        >
          <template v-slot:description>
            <a
              target="_blank"
              href="https://data.notariat.ru/directory/notary/"
              class="link"
            >
              Найдите ближайшего нотариуса на нашем портале
            </a>
          </template>
        </ItemSlider>
      </splide-slide>
    </splide>
  </v-card>
</template>

<script>
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import ItemSlider from '@/components/elements/other/SliderItemLogin';

export default {
  name: 'Slider',
  components: { ItemSlider, Splide, SplideSlide },
  props: ['full'],
  mounted() {
    if (this.full) {
      this.options.arrows = true;
      this.options.rewind = true;
    }
  },
  data() {
    return {
      options: {
        rewind: true,
        arrows: true,
        gap: '6px',
      },
    };
  },
};
</script>

<style scoped lang="scss">
.slider {
  background: $color-base;
  height: 100%;
}

.splide {
  height: 100%;
  border-radius: $border-radius;

  &::v-deep .splide__track {
    border-radius: $border-radius;
    height: 100%;
  }

  &::v-deep .splide__list {
    height: 100%;
  }

  &::v-deep .splide__arrows {
    display: none;
  }

  &::v-deep .splide__pagination__page.is-active,
  &::v-deep .splide__pagination__page:hover {
    transform: scale(1.4);
    background: white;
  }

  &::v-deep .splide__pagination__page {
    margin: 24px 10px;
    height: 6px;
    width: 6px;
  }
}

.full.splide {
  & .container {
    justify-content: unset;
    padding: 20px 10% 60px;
  }

  &::v-deep .splide__arrows {
    display: block;

    @media screen and (max-width: 1240px) {
      display: none;
    }
  }

  &::v-deep .splide__arrow svg {
    fill: rgba(0, 0, 0, 0.54);
  }

  &::v-deep .splide__arrows .splide__arrow--prev {
    left: -3em !important;
  }

  &::v-deep .splide__arrows .splide__arrow--next {
    right: -3em !important;
  }
}
</style>
